"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TraceabilityRecurringProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="traceability-recurring-process" className="bg-background">
      <div className="w-full bg-[#0F1B2D] py-20 md:py-28">
        <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8 tracking-tight">
            How Does Evermark Handle Traceability and Recurring Marking?
          </h2>
          
          <div className="space-y-6 text-lg md:text-xl text-[#E8E4DC] leading-relaxed mb-12">
            <p>
              Marine and aerospace marking is rarely one part — it is a recurring program with consistent serialization and traceability. Evermark Industrial Solutions marks variable data (serial numbers, UIIs, and data matrix values) from a customer-supplied sequence or list, and approves a first article before each program run so placement, content, and (when required) grade are confirmed.
            </p>
            <p>For recurring work, Evermark Industrial Solutions runs a standing marking program with locked-in method, layout, and serialization, so every lot matches the approved first article.&nbsp;</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 items-start sm:items-center pt-4 border-t border-white/10">
            <Link to="/OEMEquipmentManufacturersPage" className="inline-flex items-center text-[#C9A227] hover:text-white transition-colors font-semibold text-lg group">
              OEM equipment programs
              <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
            </Link>
            
            <Link to="/DirectPartMarkingDPMPage" className="inline-flex items-center text-[#C9A227] hover:text-white transition-colors font-semibold text-lg group">
              Direct part marking
              <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}